module.exports = __webpack_public_path__ + "static/img/logo-sp.e1f5145b.png";